// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"3467c52e","669":"45300076","965":"5e3293fd"}[chunkId] + ".chunk.js";
};